import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../../theme';

/**
 * Custom hook that defines the styles for the question component.
 */
const useStyles = makeStyles()(() => ({
  question: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    boxShadow: theme.containerShadow,
    fontFamily: theme.fontFamily,
    cursor: 'pointer',
    margin: theme.margin.m,
    borderRadius: theme.borderRadius.s,
    backgroundColor: theme.background.paper,
  },
  postStats: {
    color: colors.gray[300],
    textAlign: 'center',
    width: '10%',
    fontFamily: theme.fontFamily,
  },
  questionMid: {
    width: '60%',
  },
  postTitle: {
    'color': theme.primary.light,
    'fontFamily': theme.fontFamily,
    'fontWeight': theme.fontWeight.medium,
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
  questionTags: {
    marginTop: theme.margin.s,
  },
  questionTagButton: {
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.smallest,
    'fontWeight': theme.fontWeight.regular,
    'color': theme.text.primary.dark,
    'backgroundColor': colors.gray[400],
    'padding': `${theme.padding.xs} ${theme.padding.s}`,
    'borderRadius': theme.borderRadius.m,
    'marginLeft': theme.margin.s,
    'textTransform': 'none',
    'width': 'auto',
    'minWidth': 'none',
    '&:first-of-type': {
      marginLeft: 0,
    },
    '&:hover': {
      backgroundColor: colors.gray[500],
    },
    '&:active': {
      backgroundColor: colors.gray[600],
      boxShadow: theme.buttonShadow(colors.gray[600]),
    },
  },
  lastActivity: {
    fontFamily: theme.fontFamily,
    width: '30%',
    display: 'flex',
    alignContent: 'left',
  },
  questionInfo: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px',
    flex: '1',
    width: 'fit-content',
  },
  questionAuthor: {
    'color': colors.orange['400'],
    'fontFamily': theme.fontFamily,
    'fontWeight': theme.fontWeight.medium,
    'marginBottom': '5px',
    '&:hover': {
      color: colors.orange['500'],
    },
    '&:active': {
      color: colors.orange['600'],
    },
  },
  deletedQuestionAuthor: {
    color: colors.gray[300],
    pointerEvents: 'none',
  },
  questionMeta: {
    fontFamily: theme.fontFamily,
    color: colors.gray[300],
  },
}));

export default useStyles;
